import useFeatureFlags from 'pages/HomePage/hooks/useFeatureFlags';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useUserData } from './useUserData';

const useManageMyTeams = () => {
  const [isManageMyTeam, setIsManageMyTeam] = useState(false);
  const [isMyTeamCard, setIsMyTeamCard] = useState(false);
  const dataUser = useUserData();

  const { manageMyTeam } = useSelector((state: RootState) => state.configReducer).permission;

  const { isCheckGroupDeviceManagers, isCheckMyTeamCard } = useFeatureFlags({manageMyTeam} as any)

  useEffect(() => {
    setIsManageMyTeam(isCheckGroupDeviceManagers && dataUser?.isManager);
    setIsMyTeamCard(isCheckMyTeamCard && dataUser?.isManager);
  }, [isCheckGroupDeviceManagers, isCheckMyTeamCard, dataUser?.isManager]);

  return {
    isManageMyTeam, isMyTeamCard
  }
};

export default useManageMyTeams;